import { render, staticRenderFns } from "./choose-video.vue?vue&type=template&id=5a892b68&"
import script from "./choose-video.vue?vue&type=script&lang=js&"
export * from "./choose-video.vue?vue&type=script&lang=js&"
import style0 from "./choose-video.vue?vue&type=style&index=0&id=5a892b68&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports